import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { EventEmitter } from 'events';
import compose from 'recompose/compose';
import { cancelAppointment } from '../actions';
import { t } from '../../../../modules/infra/i18n';
import CancelConfirmationScreen from './confirmationScreen/cancelConfirmationScreen';
import withToggleConfirmationScreen from './confirmationScreen/withToggleConfirmationScreen';
import withNotificationState from './confirmationScreen/withNotificationState';
import { RudderstackTracker, APPOINTMENT_CANCELLED } from '../../../../modules/infra/observability/rudderstack';

class CancelAppointment extends Component {
  componentWillUpdate(nextProps) {
    if (nextProps.appointmentId !== this.props.appointmentId) {
      this.props.hideConfirmationScreen();
    }
  }

  cancelAppointment = (e) => {
    e.preventDefault();
    const {
      appointmentId,
      cancelAll,
      sendNotifications,
      hideConfirmationScreen,
    } = this.props;

    return this.props.cancelAppointment(appointmentId, cancelAll, sendNotifications).then(() => {
      hideConfirmationScreen();
      EventEmitter.prototype.emit('close-appointment-modal', 'details');
      EventEmitter.prototype.emit('appointment-canceled');
      RudderstackTracker.getInstance().track(APPOINTMENT_CANCELLED);
    });
  }

  render() {
    const {
      cancelAll,
      hideConfirmationScreen,
      setSendNotifications,
      sendNotifications,
      confirmationScreen,
      showConfirmationScreen,
    } = this.props;
    const label = cancelAll ? t('appointment:actions.cancel_all') : t('appointment:actions.cancel_appointment');
    const appointmentMessage = cancelAll ? t('appointment:cancel.all_recurring_appointments') : t('appointment:cancel.this_appointment');
    const confirmMessage = t('appointment:cancel.confirm_message', { appointmentMessage });

    return (
      <div className="u-inline-block u-1/1-medium-and-down">
        <button
          type="button"
          onClick={showConfirmationScreen}
          data-remodal-action="confirm"
          className="c-btn c-btn--grey large-and-up-ph- u-mr--"
        >
          <span className="c-btn__text">{label}</span>
        </button>
        <CancelConfirmationScreen
          display-if={confirmationScreen}
          hideConfirmationScreen={hideConfirmationScreen}
          toggleNotifications={setSendNotifications}
          cancel={this.cancelAppointment}
          sendNotifications={sendNotifications}
          message={confirmMessage}
        />
      </div>
    );
  }
}
CancelAppointment.propTypes = {
  appointmentId: PropTypes.string.isRequired,
  cancelAppointment: PropTypes.func.isRequired,
  hideConfirmationScreen: PropTypes.func.isRequired,
  cancelAll: PropTypes.bool,
  setSendNotifications: PropTypes.func.isRequired,
  sendNotifications: PropTypes.bool.isRequired,
  confirmationScreen: PropTypes.bool.isRequired,
  showConfirmationScreen: PropTypes.func.isRequired,
};
CancelAppointment.defaultProps = {
  cancelAll: false,
};

const mapDispatchToProps = {
  cancelAppointment,
};

const enhance = compose(
  withToggleConfirmationScreen,
  withNotificationState(true),
  connect(null, mapDispatchToProps),
);

export default enhance(CancelAppointment);
